import React from 'react';
import { motion } from 'framer-motion';

/** Friends doing things together leads. Home and family follow. */
const cases = [{
  emoji: '🏖️',
  title: 'Weekend away?',
  detail: 'Keep accommodation, taxis, meals and drinks in one kitty.',
  tone: 'bg-[#FFF6D6]'
}, {
  emoji: '🍻',
  title: 'Night out?',
  detail: 'Track rounds, food and taxis without remembering who paid.',
  tone: 'bg-[#FFEFE0]'
}, {
  emoji: '🎪',
  title: 'Festival or event?',
  detail: 'Keep tickets, fuel, food and group spending together.',
  tone: 'bg-[#F1EAFB]'
}, {
  emoji: '✈️',
  title: 'Big holiday?',
  detail: 'Everyone adds what they spend as the trip goes along.',
  tone: 'bg-[#E6F4F8]'
}, {
  emoji: '🏠',
  title: 'Living together?',
  detail: 'Track shopping and shared household costs without a spreadsheet.',
  tone: 'bg-[#E8F6EC]'
}, {
  emoji: '🎂',
  title: 'Family plans?',
  detail: 'Birthdays, days out and presents, split without the awkwardness.',
  tone: 'bg-[#FBEAF3]'
}];
export function UseCases() {
  return <section id="use-cases" aria-labelledby="use-cases-heading" className="bg-[#FFFBF2] py-20 lg:py-28" data-id="element-334" data-mp="2wttqzwf97rbm">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-335" data-mp="2iuua5axzggq0">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="mb-12 max-w-2xl" data-id="element-336" data-mp="2muuokvl30rx2">
          <h2 id="use-cases-heading" className="text-3xl font-black leading-[1.05] tracking-tight text-kitty-dark md:text-4xl lg:text-5xl" data-id="element-337" data-mp="3fja4dkc1fe9g">
            Going together? Put it in the pot.
          </h2>
        </motion.div>

        <motion.ul initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.05
          }
        }
      }} className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-338" data-mp="3tj1akywbbqcw">
          {cases.map(useCase => <motion.li key={useCase.title} variants={{
          hidden: {
            opacity: 0,
            y: 14
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.35,
              ease: [0.22, 1, 0.36, 1]
            }
          }
        }} className={`${useCase.tone} flex min-h-[200px] flex-col rounded-3xl p-7 transition-transform duration-150 hover:-translate-y-1`} data-id="element-339" data-mp="7xfwoplhimvc">
              <span className="mb-5 text-4xl" aria-hidden="true" data-id="element-340" data-mp="3gfc2tnd23pgl">
                {useCase.emoji}
              </span>
              <h3 className="mb-2 mt-auto text-xl font-extrabold text-kitty-dark" data-id="element-341" data-mp="3be667eg9zi1s">
                {useCase.title}
              </h3>
              <p className="text-base leading-relaxed text-kitty-dark/80" data-id="element-342" data-mp="31hbd5b2ru9uw">
                {useCase.detail}
              </p>
            </motion.li>)}
        </motion.ul>
      </div>
    </section>;
}